import type { ReactNode } from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface SectionCardProps {
  title: ReactNode;
  description?: ReactNode;
  /** Right-aligned action slot in the header. */
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** A titled content card: CardTitle + optional description and action slot. */
export function SectionCard({
  title,
  description,
  action,
  children,
  className,
}: SectionCardProps): JSX.Element {
  return (
    <Card className={className}>
      <CardHeader>
        <div className="flex items-start justify-between gap-3">
          <div className="space-y-1">
            <CardTitle className="text-base">{title}</CardTitle>
            {description && <p className="text-sm text-muted-foreground">{description}</p>}
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </div>
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
}
